export class API {
    public static galleryList = (galleryKey: string) => `gallery/${galleryKey}/list`
    public static mediaDownload = (mediaKey: string) => `media/${mediaKey}/shared-download`
    public static galleryLogout = 'gallery/logout'
}
